import { render, staticRenderFns } from "./ModalMenuItem.vue?vue&type=template&id=74b29525&scoped=true"
import script from "./ModalMenuItem.vue?vue&type=script&lang=js"
export * from "./ModalMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b29525",
  null
  
)

export default component.exports